module.exports = __webpack_public_path__ + "img/react-native.cbc7551a.svg";